/**
 * SSOT formatting utilities for bytes, speed, and ETA.
 * Used by ALL UI components — do NOT duplicate these functions.
 */

export function formatBytes(bytes: number = 0): string {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / 1024 ** i).toFixed(1)} ${units[i]}`;
}

export function formatSpeed(bytesPerSec: number = 0): string {
  if (!bytesPerSec) return '0 B/s';
  const units = ['B/s', 'KB/s', 'MB/s', 'GB/s'];
  const i = Math.floor(Math.log(bytesPerSec) / Math.log(1024));
  return `${(bytesPerSec / 1024 ** i).toFixed(1)} ${units[i]}`;
}

export function formatEta(seconds?: number): string {
  if (!seconds || seconds <= 0) return '∞';
  if (seconds < 60) return `${seconds}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m`;
  return `${Math.floor(seconds / 3600)}h`;
}

export function calculateEta(bytesRemaining: number, downloadSpeed: number): number {
  if (downloadSpeed <= 0) return -1;
  return Math.round(bytesRemaining / downloadSpeed);
}
